import { Outlet, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import Sidebar from "./Sidebar";
import MobileTopBar from "./MobileTopBar";
import PWAInstallPrompt from "@/components/PWAInstallPrompt";

export default function AppLayout() {
  const { user, ready } = useAuth();
  if (!ready) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-muted-foreground text-sm">Yükleniyor…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;

  return (
    <div className="min-h-screen flex bg-background grid-bg">
      <Sidebar />
      <div className="flex-1 min-w-0 flex flex-col">
        <MobileTopBar />
        <main className="flex-1 min-w-0 p-4 sm:p-6 md:p-8 max-w-full overflow-x-hidden">
          <Outlet />
        </main>
      </div>
      <PWAInstallPrompt />
    </div>
  );
}
